export default __webpack_public_path__ + "4c8c378ed87732f72ca7b32707b94778.woff2";